import { render, staticRenderFns } from "./weather_certificate.vue?vue&type=template&id=61f9450e&scoped=true&"
import script from "./weather_certificate.vue?vue&type=script&lang=js&"
export * from "./weather_certificate.vue?vue&type=script&lang=js&"
import style0 from "./weather_certificate.vue?vue&type=style&index=0&id=61f9450e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f9450e",
  null
  
)

export default component.exports